import "./AddToListCreateModal.scss";

import React from "react";
import { Modal, Button, Checkbox } from "react-bootstrap";
import AddToListVisibilityChanger from "./AddToListVisibilityChanger";
import { FormattedMessage } from "react-intl";
import { getIntlFormatingForPhraseProject, jsxWithIntl } from "../../i18n/IntlRootMixin";
import ErrorBoundary from "../ErrorBoundary";
import { isNil }from "../../utils/util";

type Props = {
    createNewList: (listName: string, globallyVisible: boolean, readOnlyForEmployees: boolean) => void;
    onClose: () => void;
    show: boolean;
    globallyVisible: boolean;
    selectedDeliveryAddress: {
        [x: string]: any;
    };
    isCustomer: boolean;
    //container: React.Component<any>;
};

type State = {
    intlFormatting: any;
    globallyVisible: boolean;
    readOnlyForEmployees: boolean;
    listName: string | undefined | null;
};

class AddToListCreateModal extends React.Component<Props, State> {
    state = {
        intlFormatting: getIntlFormatingForPhraseProject("EXPLORE"),
        globallyVisible: this.props.globallyVisible,
        readOnlyForEmployees: false as boolean,
        listName: null as string | null
    };

    handleSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();
        if (this.state.listName && this.state.listName !== "") {
            this.props.createNewList(this.state.listName, this.state.globallyVisible, this.state.readOnlyForEmployees);
        }
        this.props.onClose();
        return false;
    };

    handleListChangeName = (e: React.SyntheticEvent) => {
        this.setState({
            listName: (e.target as any).value
        });
    };

    changeVisibility = (event: React.SyntheticEvent) => {
        this.setState({ globallyVisible: (event.target as any).value === "globallyVisible" });
    };

    changeReadOnlyForEmployees = () => {
        this.setState({
            readOnlyForEmployees: !this.state.readOnlyForEmployees
        });
    };

    render() {
        // Allow user to make new list non globally visible only if a delivery address is selected.
        const showGloballyVisibleChanger = !isNil(this.props.selectedDeliveryAddress);

        return (
            <ErrorBoundary>
                <>
                    {jsxWithIntl(
                        <Modal
                            //container={this.props.container}
                            keyboard
                            animation
                            onHide={this.props.onClose}
                            show={this.props.show}
                            className="ca-list-create-modal">
                            <Modal.Header closeButton>
                                <Modal.Title>{<FormattedMessage id="ORC_CREATE_NEW_LIST" />}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <form role="form" onSubmit={this.handleSubmit}>
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            maxLength={40}
                                            className="form-control"
                                            autoFocus
                                            placeholder={this.state.intlFormatting.formatMessage({
                                                id: "ORC_NAME_YOUR_LIST"
                                            })}
                                            onChange={this.handleListChangeName}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <AddToListVisibilityChanger
                                            initialValue={this.state.globallyVisible}
                                            showGloballyVisibleChanger={showGloballyVisibleChanger}
                                            isGloballyVisibleChangerActive
                                            changeVisibility={this.changeVisibility}
                                        />
                                    </div>
                                    {this.props.isCustomer && (
                                        <Checkbox
                                            checked={this.state.readOnlyForEmployees}
                                            onChange={this.changeReadOnlyForEmployees}>
                                            <FormattedMessage
                                                className="checkbox-label"
                                                id="EX_LIST_CREATE_EDIT_MODAL_RESTRICT_EMPLOYEE_EDITING"
                                            />
                                        </Checkbox>
                                    )}
                                </form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button onClick={this.props.onClose}>
                                    <FormattedMessage id="EX_CANCEL_MODAL" />
                                </Button>
                                <button
                                    type="submit"
                                    value="create"
                                    className="btn btn-primary test-create-list"
                                    onClick={this.handleSubmit}>
                                    <FormattedMessage id="ORC_SAVE_NEW_LIST" />
                                </button>
                            </Modal.Footer>
                        </Modal>,
                        "EXPLORE"
                    )}
                </>
            </ErrorBoundary>
        );
    }
}

export default AddToListCreateModal;
